import { createIcon } from "@chakra-ui/react";

const MinusIcon = createIcon({
  displayName: "MinusIcon",
  viewBox: "0 0 9 9",
  path: (
    <g>
      <rect
        x="0.5"
        y="1.06519"
        width="7.57143"
        height="7.34783"
        rx="3.67391"
        stroke="#E56262"
        fill="transparent"
      />
      <path d="M6.42857 4.73901L2.14286 4.73901" stroke="#E56262" />
    </g>
  )
});

export default MinusIcon;
